import { render, staticRenderFns } from "./LandingOnboarding.vue?vue&type=template&id=272fa12a&scoped=true"
import script from "./LandingOnboarding.vue?vue&type=script&lang=js"
export * from "./LandingOnboarding.vue?vue&type=script&lang=js"
import style0 from "./LandingOnboarding.vue?vue&type=style&index=0&id=272fa12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272fa12a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingOnboardingNl: require('/src/components/landing/LandingOnboardingNl.vue').default,LandingMyAdItem: require('/src/components/landing/LandingMyAdItem.vue').default})
